<template>
  <v-list-item
    v-bind="itemAttrs"
    v-on="listItemListeners"
  >
    <v-list-item-action :class="checkboxClass">
      <Checkbox
        :input-value="checked"
        :color="color"
        :disabled="disabled"
        :indeterminate="indeterminate"
        @click.native.stop
        @change="emitToggle"
      />
    </v-list-item-action>

    <v-list-item-content>
      <v-list-item-title :class="titleClass">
        {{ title }}
      </v-list-item-title>
      <v-list-item-subtitle v-if="subtitle">
        {{ subtitle }}
      </v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import Checkbox from '@/tools/components/Checkbox.vue'

export default {
  name: 'CheckboxOptionRow',
  components: {
    Checkbox,
  },
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    checkboxClass: {
      type: String,
      default: 'mr-2',
    },
    useVuetifyItemHandlers: {
      type: Boolean,
      default: false,
    },
    itemAttrs: {
      type: Object,
      default: () => ({}),
    },
    itemOn: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    listItemListeners() {
      if (this.useVuetifyItemHandlers) {
        return this.itemOn
      }

      return {
        click: this.emitToggle,
      }
    },
  },
  methods: {
    emitToggle() {
      if (!this.disabled) {
        this.$emit('toggle')
      }
    },
  },
}
</script>
